import React, { createContext } from 'react';

export const PropiedadContext = createContext();